import { Dialog } from '@chakra-ui/react';
import { ReactNode } from 'react';

export const ModalFooter = ({ children }: { children: ReactNode }) => (
  <Dialog.Footer>{children}</Dialog.Footer>
);
